import React from 'react';
import { ActionsMenu } from '../ActionsMenu';
import usePermissions from '../../../hooks/usePermissions';

// 'Y-m-d H:i:s' es hora del servidor. Se pasa a ISO local para que new Date() no
// tenga que adivinar la zona horaria.
function formatLastSession(value) {
    if (!value) return null;
    const parsed = new Date(String(value).replace(' ', 'T'));
    if (isNaN(parsed.getTime())) return String(value);
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    return `${pad(parsed.getDate())}/${pad(parsed.getMonth() + 1)}/${parsed.getFullYear()} ${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
}

export function UsersTable({ users, onEdit, onNotify, onDelete, onAssignPrimary, onToggleActive }) {
    // Cada boton con SU permiso. Antes de esto la columna Acciones era la misma para
    // todos: un rol que solo podia leer la lista se encontraba con los cinco botones y
    // recibia un 403 al pulsarlos. El backend es la autoridad final; esto solo evita
    // ofrecer acciones que no iban a funcionar.
    const { can } = usePermissions();

    if (users.length === 0) {
        return (
            <div className="text-center py-5 text-white-50">
                <h6 className="m-0 opacity-50">No se encontraron usuarios para los filtros aplicados</h6>
            </div>
        );
    }

    return (
        <div className="modern-table-container">
            <table className="modern-table striped-table">
                <thead>
                    <tr>
                        <th>Usuario</th>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th>Rol</th>
                        <th>Cuenta</th>
                        <th>Principal</th>
                        <th>Estado</th>
                        <th>Última sesión</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((u) => {
                        const isActive = u.active === 1;
                        const lastSession = formatLastSession(u.last_session_at);
                        const items = [];
                        if (can('users', 'edit')) {
                            items.push({ label: 'Editar', onClick: () => onEdit(u) });
                        }
                        if (can('users', 'notify')) {
                            items.push({ label: 'Notificar cuenta lista', onClick: () => onNotify(u) });
                        }
                        if (isActive && u.editorial && can('users', 'assign_primary')) {
                            items.push({ label: 'Asignar como principal', onClick: () => onAssignPrimary(u) });
                        }
                        // Desactivar y reactivar son la misma accion con dos estados.
                        // Se separa de "Eliminar", que si borra la contrasena y no tiene
                        // vuelta atras desde esta misma pantalla.
                        if (can('users', 'toggle_active')) {
                            items.push({
                                label: isActive ? 'Desactivar' : 'Reactivar',
                                onClick: () => onToggleActive(u),
                            });
                        }
                        if (can('users', 'delete')) {
                            items.push({ label: 'Eliminar', danger: true, onClick: () => onDelete(u) });
                        }
                        return (
                            <tr key={u.id}>
                                <td className="short fw-bold text-white">{u.user}</td>
                                <td className="short text-white-50">
                                    {[u.name, u.ap_pat, u.ap_mat].filter(Boolean).join(' ')}
                                </td>
                                <td className="short text-white-50">{u.email}</td>
                                <td className="short">
                                    <span className="badge-status">{u.role_name || u.type}</span>
                                </td>
                                <td className="short text-white-50">
                                    {u.account_prefix ? `[${u.account_prefix}] ` : ''}{u.editorial}
                                </td>
                                <td className="short">
                                    {u.is_primary === 1 ? (
                                        <span className="badge-status status-on">Principal</span>
                                    ) : (
                                        <span className="text-white-50">—</span>
                                    )}
                                </td>
                                <td className="short">
                                    <span className={`badge-status ${isActive ? 'status-on' : 'status-off'}`}>
                                        {isActive ? 'Activo' : 'Inactivo'}
                                    </span>
                                </td>
                                <td className="short text-white-50">
                                    {lastSession || <span className="opacity-50">Nunca</span>}
                                </td>
                                <td>
                                    {/* Un menu sin entradas es peor que ninguno: es un
                                        boton que se abre y esta vacio. Ademas el hook
                                        falla cerrado mientras carga, asi que sin este
                                        guardia la celda parpadearia en cada montaje. */}
                                    {items.length > 0
                                        ? <ActionsMenu items={items} title="Acciones del usuario" />
                                        : <span className="text-white-50">&mdash;</span>}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default UsersTable;
